import { ButtonTab } from "@/components/Button/ButtonTab"
import { Container } from "@/components/Container"
import { VerificationForm } from "@/components/verification/VerificationForm"
import { VerificationSteps } from "@/components/verification/VerificationSteps"
import { ClientType, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import clsx from "clsx"
import { memo } from "react"
import { FormattedMessage } from "react-intl"
import { NavLink, Route, Switch, useLocation, useParams, useRouteMatch } from "react-router-dom"

const Link = ({ path, title, isMobile }: { title: string; path: string; isMobile?: boolean }) => (
  <NavLink
    to={path}
    activeClassName="btn-blue active !text-[#78ff73]"
    className={clsx("btn-reset btn-sq btn-trpr input-brdr no-decorate md:w-auto text-center", { "w-[50%]": !isMobile })}
  >
    <FormattedMessage id={title} />
  </NavLink>
)
const VerificationsPageComponent = () => {
  const { client_type, card_active, iban_active } = useStoreClient(selectUser)
  const isCorporateAccount = client_type === ClientType.Coroporate
  const path = useRouteMatch().path
  const pathname = useLocation().pathname
  const { type } = useParams<{ type?: string }>()
  const formPath = isCorporateAccount ? "corporate-details" : "personal-details"
  return (
    <Container maxW={980}>
      <div className="div-h1 text-center">
        <FormattedMessage id="account_verification" />
      </div>
      <ButtonTab
        className="my-4 max-w-fit"
        items={[
          {
            title: <FormattedMessage id="verification_exchange" />,
            to: pathname.replace(`/${type}`, "/exchange"),
          },
          {
            title: <FormattedMessage id="verification_card" />,
            to: pathname.replace(`/${type}`, "/card"),
            hide: isCorporateAccount || !card_active,
          },
          {
            title: <FormattedMessage id="for_bank_account_opening" />,
            to: pathname.replace(`/${type}`, "/bank_account"),
            hide: !iban_active,
          },
        ]}
      />

      <div className="additional-links d-flex justify-content-center mb-xs">
        <NavLink to={`${path.replace(/:.*\??/, type ?? "")}`} exact className="additional-links__link">
          <h3 className="h4 additional-links__link-title">
            <FormattedMessage id="pa_147" />
          </h3>
        </NavLink>
        <NavLink to={`${path.replace(/:.*\??/, type ?? "")}/${formPath}`} className="additional-links__link">
          <h3 className="h4 additional-links__link-title">
            <FormattedMessage id="pa_148" />
          </h3>
        </NavLink>
      </div>
      <Switch>
        <Route path={`${path}`} exact component={VerificationSteps} />
        <Route path={`${path}/${formPath}`} component={VerificationForm} />
      </Switch>
    </Container>
  )
}

export const VerificationsPage = memo(VerificationsPageComponent)
